import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: process.env.VUE_APP_KEYCLOAK_URL || 'http://localhost:8888', // URL do seu servidor Keycloak
  realm: process.env.VUE_APP_KEYCLOAK_REALM,// || 'Teste',                // Nome do seu "Realm"
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENTID || 'vue-app',               // Nome do seu client no Keycloak
});

export default keycloak;